// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"c62dc02ed1ab289e95cf","453":"7d2134de2b2868205a7c"}[chunkId] + ".js";
};